import { render, staticRenderFns } from "./GenealogyNode.vue?vue&type=template&id=954bb36e&scoped=true"
import script from "./GenealogyNode.vue?vue&type=script&lang=js"
export * from "./GenealogyNode.vue?vue&type=script&lang=js"
import style0 from "./GenealogyNode.vue?vue&type=style&index=0&id=954bb36e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954bb36e",
  null
  
)

export default component.exports